import { useAuthenticatedQuery } from '../../useAuthenticatedQuery.js';
import PropTypes from 'prop-types';
import axios from 'axios';
import { API_BASE_URL, FUNCTION_KEY, PROJECT_SCOPE } from '../../../config.js';
import useUser from '@datahooks/useUser.js';
import logError from '@datahooks/metadata/ErrorLogging.js';

export default function useOrganisationKeys(orgId, enabled = true) {
  const { user:userDetails } = useUser();
  const hasValidOrgId = Number.isInteger(orgId) && orgId > 0;

  const fetchOrganisationKeys = async (token) => {
    if (!hasValidOrgId) {
      return [];
    }

    try {
      const response = await axios.get(`${API_BASE_URL}disqoadmin/organisation_keys?org_id=${orgId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'x-functions-key': FUNCTION_KEY
        }
      });
      return response.data;
    } catch (error) {
      logError('Failed to load organisation keys in useOrganisationKeys', error, {}); // Error during fetch
      throw error;
    }
  };
  
  const { data: organisationKeysData = [], isLoading, refetch, error } = useAuthenticatedQuery(`organisations_keys_${userDetails?.id}_${orgId}`, fetchOrganisationKeys, [PROJECT_SCOPE], {
    staleTime: Infinity, // The data will never be considered stale. If the result is in a pending state, a refetch button will be available
    enabled: enabled && hasValidOrgId
  });

  return { organisationKeysData, organisationKeysLoading: isLoading, refetchOrganisationKeys: refetch, organisationKeysError: error };
}

useOrganisationKeys.propTypes = {
  orgId: PropTypes.number,
  enabled: PropTypes.bool
}